export default __webpack_public_path__ + "static/media/IMG-20240822-WA0007.2ce85475.jpg";